module.exports = __webpack_public_path__ + "img/creditcard.2ed0422c.svg";